import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import {
  OrganisationType,
  getOrganisations,
  postUpdateOrganisation,
} from "@intelligentlilli/api-layer";
import { useAppSelector } from "State/hooks";
import LoadingBubbles from "Components/LoadingBubbles";
import { SERVER } from "../../Services/config";
import LilliSelect from "Components/LilliDesignSystem/LilliSelect";

const ChangeOrganisation = () => {
  const user = useAppSelector((state) => state.user.authData);
  const isAdmin = !!user?.roles?.includes("admin");
  const [organisations, setOrganisations] = useState<OrganisationType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingOrgs, setIsLoadingOrgs] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [organisation, setOrganisation] = useState<
    { label: string; value: number } | undefined
  >();

  useEffect(() => {
    async function fetchData() {
      setIsLoadingOrgs(true);
      try {
        const res = await getOrganisations(SERVER, "web");
        if (res.status === 200 && res.data) {
          setOrganisations(res.data);
          const currentOrg = res.data.find(
            (org) => org.id === user?.organisationId
          );
          if (currentOrg) {
            setOrganisation({
              label: currentOrg.name,
              value: currentOrg.id,
            });
          }
        }
      } catch (error) {
        console.error("Failed to fetch organisations:", error);
      } finally {
        setIsLoadingOrgs(false);
      }
    }
    fetchData();
  }, [user?.organisationId]);

  const updateOrganisation = async (org: { label: string; value: number }) => {
    setIsLoading(true);
    setShowSuccess(false);
    setError(undefined);
    try {
      const res = await postUpdateOrganisation(SERVER, `${org.value}`, "web");
      if (res.status === 200) {
        console.log("Organisation updated successfully");
        setOrganisation(org);
        setShowSuccess(true);
      } else {
        setError(`Failed to update organisation: ${res.status}`);
      }
    } catch (error) {
      console.error("Failed to update organisation:", error);
      setError(`Failed to update organisation: ${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      {isAdmin && (
        <>
          <h4>Change organisation (admin only)</h4>
          <div className={styles.orgSelect}>
            <LilliSelect
              placeholder="Change organisation"
              options={organisations
                .filter((org) => org.active)
                .map((org) => ({
                  label: org.name,
                  value: org.id,
                }))}
              name="organisations"
              value={organisation}
              onChange={(value: any) => {
                updateOrganisation(value);
              }}
              withinModal={false}
              isDisabled={isLoading}
              inputStyles={{ minWidth: 240, marginRight: 8 }}
            />
            {(isLoading || isLoadingOrgs) && <LoadingBubbles />}
          </div>
          {error && <p className={styles.error}>{error}</p>}
          {showSuccess && (
            <p className={styles.success}>
              Organisation updated successfully! Log out and in again to see the
              new organisation.
            </p>
          )}
        </>
      )}
    </>
  );
};

export default ChangeOrganisation;
